import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axios from "../helpers/axios";
import Layout from "../components/global/Layout";
import PartTable from "../components/parts/PartTable";

const BranchOrders = () => {
  const [isLoading, setLoading] = useState(false);
  const [branch, setBranch] = useState({});
  const [parts, setParts] = useState([]);
  const { id } = useParams();

  const loadData = async (id) => {
    setLoading(true);
    const branch = await axios.get(`/api/branch/${id}/`);
    const orders = await axios.get(`/api/branch/${id}/orders/`);

    setBranch(branch.data);
    setParts(orders.data);
    setLoading(false);
  };

  useEffect(() => {
    loadData(id);
  }, [id]);

  if (isLoading) {
    return (
      <Layout>
        <section className="hero">
          <div className="hero-body">
            <div className="container has-text-centered">
              <h1 className="title">Cargando</h1>
              <h2 className="subtitle">
                Obteniendo información desde el servidor
              </h2>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <div
        className="container"
        style={{
          padding: "2rem",
        }}
      >
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div>
                <h1 className="title is-2">Sucursal {branch.id}</h1>
                <br />
                <h2 className="subtitle">{branch.name}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "1rem",
        }}
      >
        <PartTable
          parts={parts}
          onChange={() => {
            loadData();
          }}
        />
      </div>
    </Layout>
  );
};

export default BranchOrders;
